import React, { Component, PropTypes } from 'react';

const PreviewIconLink = ({ fontData, text, icon, className }) => {
    return (
        <div className={className}>
            <a
                href="#"
                style={{
                    fontFamily: fontData.font,
                    textAlign: fontData.align,
                    lineHeight: fontData.lineHeight,
                    textDecoration: fontData.decoration,
                    fontStyle: fontData.style,
                    color: fontData.color,
                    hoverColor: fontData.hoverColor,
                    fontWeight: fontData.weight,
                    fontSize: fontData.size
                }}
            >
                {text} <span className={icon} />
            </a>
        </div>
    );
};

PreviewIconLink.propTypes = {
    fontData: PropTypes.object,
    text: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string
};

export default PreviewIconLink;



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/PreviewIconLink.js